import Splide from '@splidejs/splide';

const gk_testimonyBlock = {
  load() {
    const blocks = document.querySelectorAll('.TestimonyBlock');
    blocks.forEach((block) => {
      if (block.dataset.gkInit) return;
      block.dataset.gkInit = '1';

      const mode = block.dataset.mode;

      if (mode === 'slider') {
        this.initSplide(block);
      }
    });
  },

  initSplide(block) {
    const splideEl = block.querySelector('.TestimonyBlock-splide');
    if (!splideEl) return;

    const slideCount = splideEl.querySelectorAll('.splide__slide').length;
    if (slideCount < 2) return;

    const speed               = parseInt(block.dataset.speed, 10) || 750;
    const autoplay            = block.dataset.autoplay === '1';
    const autoplaySpeed       = parseInt(block.dataset.autoplaySpeed, 10) || 3000;
    const rewind              = block.dataset.rewind === '1';
    const showArrows          = block.dataset.showArrows === '1';
    const showDots            = block.dataset.showDots === '1';

    const perPageDesktopLarge = parseInt(block.dataset.perPageDesktopLarge, 10) || 3;
    const perPageDesktop      = parseInt(block.dataset.perPageDesktop, 10) || 3;
    const perPageTabletLarge  = parseInt(block.dataset.perPageTabletLarge, 10) || 2;
    const perPageTablet       = parseInt(block.dataset.perPageTablet, 10) || 2;
    const perPageMobileLarge  = parseInt(block.dataset.perPageMobileLarge, 10) || 1;
    const perPageMobile       = parseInt(block.dataset.perPageMobile, 10) || 1;

    const safeMax = (n) => Math.min(n, slideCount);

    const splide = new Splide(splideEl, {
      type:       rewind ? 'loop' : 'slide',
      perPage:    safeMax(perPageDesktopLarge),
      perMove:    1,
      speed,
      autoplay,
      interval:   autoplaySpeed,
      pauseOnHover: true,
      pauseOnFocus: true,
      arrows:     showArrows,
      pagination: showDots,
      gap:        'var(--tm-gap, 16px)',
      easing:     'cubic-bezier(0.76, 0, 0.24, 1)',
      keyboard:   'global',
      i18n: {
        prev:   'Témoignage précédent',
        next:   'Témoignage suivant',
        first:  'Premier témoignage',
        last:   'Dernier témoignage',
        slideX: 'Témoignage %s',
        pageX:  'Page %s',
      },
      breakpoints: {
        1199: { perPage: safeMax(perPageDesktop) },
        1023: { perPage: safeMax(perPageTabletLarge) },
         990: { perPage: safeMax(perPageTablet) },
         767: { perPage: safeMax(perPageMobileLarge) },
         399: { perPage: safeMax(perPageMobile) },
      },
    });

    splide.mount();
    splideEl._splide = splide;
  },

};

export default gk_testimonyBlock;
